import { AwsComponentKey } from "@p0security/shared/integrations/resources/aws/types";
import { NEW_SENTINEL } from "components/Integrations/Install/Component";
import { DOCS_URLS } from "constants/docsUrls";
import React, { useCallback } from "react";
import { Link } from "react-router-dom";

import { useNavigateWithSearchParams } from "../../Assessment/hooks/useNavigateWithSearchParams";
import { InstallPromptStep } from "../components/Prompt";
import { WelcomePaths, useWelcomePath } from "../paths";

const ResourcePrompt = React.memo(() => {
  const navigateWithSearchParams = useNavigateWithSearchParams();
  const buildWelcomePath = useWelcomePath();

  const navigateToInventory = useCallback(() => {
    const componentKey: AwsComponentKey = "inventory";
    navigateWithSearchParams(
      buildWelcomePath(`${componentKey}/${NEW_SENTINEL}`)
    );
  }, [navigateWithSearchParams, buildWelcomePath]);

  const handleNo = useCallback(() => {
    navigateWithSearchParams(buildWelcomePath(WelcomePaths.ConfigureApprovers));
  }, [navigateWithSearchParams, buildWelcomePath]);

  return (
    <InstallPromptStep
      prompts={[
        {
          title: "Install Resource Inventory?",
          features: [
            "Do you plan on making access requests to individual resources?",
            "If yes, you will need to install P0's Resource Inventory.",
            "You can always install it later if you change your mind.",
            <Link
              key="learn-more-link"
              to={DOCS_URLS.AWS_INVENTORY}
              target="_blank"
              rel="noreferrer"
            >
              Learn more in the docs
            </Link>,
          ],
          onPrimary: {
            text: "Install now",
            shortText: "Install",
            onClick: navigateToInventory,
          },
          onSecondary: {
            text: "Install later",
            shortText: "Later",
            onClick: handleNo,
          },
        },
      ]}
    />
  );
});

ResourcePrompt.displayName = "ResourcePrompt";

export { ResourcePrompt };
